import { isSafari, playoutStoreDataResolver } from 'utils';

export function checkAbilityCaptionsStyling(): boolean {
  const { isVod } = playoutStoreDataResolver();

  return isVod || isSafari();
}
